export default "__VITE_ASSET__D47MsKPb__"